module.exports = __webpack_public_path__ + "img/maket_atlas_-38b911bee5952d6f3d3689340195b02a.png";


//////////////////
// WEBPACK FOOTER
// ./temp/img/maket_atlas_.png
// module id = 368
// module chunks = 0